module.exports = __webpack_public_path__ + "img/556.2561f21b.jpg";